/**
 * JSON-LD has to be part of the server-rendered HTML: `next/script` injects
 * inline scripts from the client after hydration, so the markup was missing
 * from the raw document that crawlers fetch. A plain `<script>` tag is what
 * Next.js recommends for structured data.
 *
 * `<` is escaped so a `</script>` sequence inside the data cannot close the
 * tag early.
 */
export default function JsonLd({ id, data }: { id: string, data: any }) {
  return (
    <script
      id={id}
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(data).replace(/</g, "\\u003c"),
      }}
    />
  );
}
